import React from 'react'
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import AutomobileBillingSoftware from '@/components/outlet/AutomobileBillingSoftware';

const automobileBillingSoftware = () => {
  return (
    <>
      <Head>
      <title>QueueBuster Automobile Billing Software | Simplify Automobile Store Operations</title>
        <link rel="canonical" href="https://queuebuster.co/outlet/automobile-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/outlet/automobile-billing-software" hrefLang="en-us" />
        <meta name="description" content="Manage billing, inventory, and customer loyalty seamlessly with QueueBuster Automobile Billing Software. Perfect for car and bike accessory stores and service centers." />
        <meta property="og:title" content="QueueBuster POS for Automobile Stores: Efficient Billing Made Easy" />
        <meta property="og:description" content="Streamline your automobile store operations with QueueBuster POS. Handle billing, inventory, and CRM effortlessly for service centers and accessory shops." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/pikaso_embed.png" />
        <meta property="og:url" content="https://queuebuster.co/outlet/automobile-billing-software" />
      </Head>
         <SchemaTags page="automobile-billing-software" />
      <AutomobileBillingSoftware />
    </>
  )
}

export default automobileBillingSoftware